import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { BaseObject } from '../shared/baseClass';
import { AuthService, User } from '../user/auth.service';
import { Guest } from '../website-builder/wedding';
import { Http, RequestOptions } from '@angular/http';
import { SettingsStateStore } from '../settings/settings.state.store';
import { Settings } from '../settings/settings';

export interface State {
  guests: Guest[];
  user: User | null;
}

@Injectable()
export class GuestStateStore {
  settings: Settings;
  updateGuestsBulk(guestsToUpdate: Guest[]) {
    guestsToUpdate.forEach(guest => {
      this.updateGuest(guest);
    });
  }


  private state$: BehaviorSubject<State>;
  private userId: string;

  FIRESTORE_GUEST_DOCUMENT_COLLECTION_NAME = 'guests';
  constructor(
    private firestore: AngularFirestore,
    private authService: AuthService,
    private afs: AngularFirestore,
    private _settingsStateStore: SettingsStateStore,
    private _http: Http
  ) {

    this._settingsStateStore.getState().subscribe(state => {
      if(state && state.settings){
        this.settings = state.settings;
      }

    });
    this.state$ = new BehaviorSubject<State>({
      guests: [],
      user: null
    });


    this.authService.user.take(1).subscribe(user => {
      if (user) {
        this.userId = user.uid;
        return this.afs
          .collection<Guest[]>(this.FIRESTORE_GUEST_DOCUMENT_COLLECTION_NAME, ref =>
            ref.where('userId', '==', this.userId)
          )
          .snapshotChanges()
          .subscribe(x => {
            if (x && x.length > 0 && x[0].payload) {


              const newState: State = {

                guests: x.map(data => {
                  const guest = data.payload.doc.data() as Guest;
                  guest.id = data.payload.doc.id;
                  guest.selected = false;
                  return guest;
                }),
                user: this.state$.value.user
              };

            //if there are any guests that isPlusOneTo is not null, and the host with the same Id is not in a party then set both of them to have the same partyId as the host id
            let guests = newState.guests;
            guests.forEach(guest => {
              if(guest.isPlusOneTo){
                let host = guests.find(g => g.id === guest.isPlusOneTo);
                if(host && host.partyName !== guest.partyName){
                  host.partyName = host.id;
                }
              }
            }
            );
            newState.guests = guests;

              this.updateState(newState);
            } else {

              const newState: State = {
                guests: [],
                user: this.state$.value.user
              };
              this.updateState(newState);
            }
          });

      } else {
        // throw new Error('no user ID supplied: Hitchd crash error');
      }
    });



  }

  getState(): Observable<State> {
    return this.state$.asObservable();
  }
  getPartySize(guest: Guest): number {

    let party = this.state$.value.guests.filter(g => g.partyName === guest.partyName);
    return party.length;
  }
  searchGuestApi(searchName: string, userId:string) : Promise<Guest[]>  {
    let websiteUserId = userId;
 
  
    let requestObject = {searchName, userId: websiteUserId};
    let requestOptions = new RequestOptions({ search: requestObject }); 
    // Save the guest document
    const url = environment.firebase.clouldFunctionHost+'/searchGuests'; // Replace with your API URL
     return this._http.get(url,requestOptions )
      .toPromise()
      .then((data) => {
        if (data && data.json()) {
         let guests: Guest[] = data.json();
       return  guests;
        } else {
          return [];
        }
      })
      .catch(error => { console.error('Error updating wedding: ', error)
      throw error;
  });


  }
  searchGuest(searchName: string): Guest[] {
    const lowerCaseSearchName = searchName.toLowerCase();
    const searchWords = lowerCaseSearchName.split(' ');
    const newState = this.state$.value;
  
    let guests = newState.guests.filter(guest => {
      const firstName = guest.firstName ? guest.firstName.toLowerCase() : '';
      const lastName = guest.lastName ? guest.lastName.toLowerCase() : '';
      const fullName = `${firstName} ${lastName}`.trim();
  
      const nameMatch = searchWords.every(word =>
        firstName.includes(word) || lastName.includes(word) || fullName.includes(word)
      );
  
      const isInvitedToEvent = guest.rsvpStatus &&
        Object.values(guest.rsvpStatus).some(status =>
          status !== null && status.toLowerCase() !== 'not-invited'
        );
  
      return nameMatch && isInvitedToEvent;
    });
  
    return guests;
  }


  updateState(newState: State) {

    this.state$.next(newState);
  }

  addGuest(guest: Guest) {
    this.setCreated(guest, this.userId);
    guest.selected = null;
    guest.id = this.firestore.createId();
    const guestObj = { ...guest };
    this.reviewSettings();
    this.firestore.collection(this.FIRESTORE_GUEST_DOCUMENT_COLLECTION_NAME).doc(guest.id).set(guestObj)
      .then(() => {})
      .catch(error => console.error('Error adding wedding: ', error));
  }

  reviewSettings(){
    if(this.settings && !this.settings.hasUpdatedGuestList){
      this.settings.hasUpdatedGuestList = true;
      this._settingsStateStore.updateSettings(this.settings);
    }
  }

  updateGuestViaApi(guest: Guest, token: string) {
  // Validate the guest
  if (!guest || guest.id === null || guest.id === undefined) {
    console.error('Invalid guest');
    return;
  }

  let websiteUserId = guest.userId;
  let guestEmail = guest.email; 

  let requestObject = {...guest, websiteUserId, guestEmail, token};

  // Save the guest document
  const url = environment.firebase.clouldFunctionHost+'/updateGuest'; // Replace with your API URL
  return this._http.post(url, requestObject)
    .toPromise()
    .then(() => {})
    .catch(error => console.error('Error updating wedding: ', error));
  }

  addGuestViaApi(guest: Guest, websiteUserId: string, token: string) {

guest.userId = websiteUserId;;  
  let guestEmail = guest.email; 

  let requestObject = {...guest, websiteUserId, guestEmail, token};

  // Save the guest document
  const url = environment.firebase.clouldFunctionHost+'/addGuest'; // Replace with your API URL
  return this._http.post(url, requestObject)
    .toPromise()
    .then(() => {})
    .catch(error => console.error('Error updating wedding: ', error));
    }
  
  

  updateGuest(guest: Guest) {

    if(guest.id == 'sampleguest'){
      guest.id = null;
    }
    if (guest.id === null || guest.id === undefined) {
      guest.selected = null;

      return this.addGuest(guest);
    }

    this.setUpdated(guest);
    this.reviewSettings();
    const guestObj = { ...guest };
    return this.afs
      .collection(this.FIRESTORE_GUEST_DOCUMENT_COLLECTION_NAME).doc(guest.id).update(
        guestObj
      )
      .then(() => {
        
      }
      )
      .catch(error => {
        console.error('Error updating wedding: ', error)
      }
      );
  }

  bulkUpdateGuests(guests: Guest[]) {
    this.reviewSettings();
    this.afs.firestore.runTransaction(transaction => {
      guests.forEach(guest => {
        const guestRef = this.afs.collection(this.FIRESTORE_GUEST_DOCUMENT_COLLECTION_NAME).doc(guest.id).ref;
        transaction.update(guestRef, guest);
      });
      return Promise.resolve();
    });

  }




  bulkAddGuests(guests: Guest[]): Promise<void> {
    this.reviewSettings();
    return this.afs.firestore.runTransaction(transaction => {
      guests.forEach(guest => {
        this.setCreated(guest, this.userId);
        guest.id = this.firestore.createId();
        guest.isPlusOneTo = guest.isPlusOneTo || null; // Set to null if undefined
  

        //if any values are undefined set to null
        for (const key in guest) {
          if (guest[key] === undefined) {
            guest[key] = null;
          }
        }

        const guestObj = { ...guest };
  
        const guestRef = this.afs.collection(this.FIRESTORE_GUEST_DOCUMENT_COLLECTION_NAME).doc(guest.id).ref;
        transaction.set(guestRef, guestObj);
      });
      return Promise.resolve();
    });
  }


  bulkDeleteGuests(guests: Guest[]) {
    this.reviewSettings();
    this.afs.firestore.runTransaction(transaction => {
      guests.forEach(guest => {
        const guestRef = this.afs.collection(this.FIRESTORE_GUEST_DOCUMENT_COLLECTION_NAME).doc(guest.id).ref;
        transaction.delete(guestRef);
      });
      return Promise.resolve();
    });
  }
  deleteGuest(guest: Guest) {
    this.reviewSettings();
    this.afs
      .collection(this.FIRESTORE_GUEST_DOCUMENT_COLLECTION_NAME).doc(guest.id).delete()
      .then(() => {
     
      }
      )
      .catch(error => {
        console.error('Error deleting wedding: ', error)
      }
      );
  }

  private setCreated(baseObject: BaseObject, userId: string) {
    if (!userId) {
      throw new Error('no user ID supplied: Hitchd crash error');
    }

    const now = Date.now();
    baseObject.createdDate = now;
    baseObject.modifiedDate = now;
    baseObject.userId = userId;
  }
  private setUpdated(baseObject: BaseObject) {
    const now = Date.now();
    baseObject.modifiedDate = now;
  }

}


// WEBPACK FOOTER //
// ./src/app/guest-list/guest.state.store.ts